// src/api/mock/dashboard.js
export const mockDashboard = {
  totals: {
    totalProducts: 87,
    totalStock: 312,
    totalOutOfStock: 4,
    totalAmount: 132.75, // sales invoice total (KWD)
  },
  general: {
    suppliers: 7,
    customers: 28,
    orders: 12,
  },
  topProducts: [
    { productId: 1, productName: { en: "Blue T-Shirt" }, image: "assets/img/products/product-01.jpg", quantitySold: 46, revenue: 420.5 },
    { productId: 2, productName: { en: "Wireless Mouse" }, image: "assets/img/products/product-02.jpg", quantitySold: 29, revenue: 290.9 },
  ],
  lowStock: [
    { productId: 91, productName: "USB-C Cable", sku: "USBC-1M", image: "assets/img/products/product-03.jpg", quantity: 2 },
    { productId: 92, productName: "Paper Rolls", sku: "ROLL-80", image: "assets/img/products/product-04.jpg", quantity: 1 },
  ],
  recentSales: [
    { id: "s1", source: "invoice", title: "INV-1001", amount: 38.9, date: new Date().toISOString(), status: "Paid" },
    { id: "s2", source: "online",  title: "ORD-2331", amount: 24.5, date: new Date().toISOString(), status: "Completed" },
  ],
  saleRows: [
    { id: "sr1", date: new Date().toISOString(), customer: { name: "Isha" }, orderId: "SO-102", status: "Completed", total: 52.4 },
  ],
  invRows: [
    { id: "iv1", customer: { name: "Mohamed" }, reference: "INV-1002", dueDate: new Date().toISOString(), status: "Paid", amount: 38.9 },
  ],
  stats: {
    categories: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    series: { revenue: [3,6,5,7,9,8,7,6,7,9,10,11].map(n=>n*100) },
    totals: { revenue: 5500, orders: 80, expense: null },
    yoy: { revenuePct: 12 },
  },
  topCustomers: [
    { id: 1, name: "Khaled", country: "KW", orders: 6, totalSpent: 420.2, image: "assets/img/customer/customer11.jpg" },
  ],
  topCategories: {
    items: [
      { categoryId: 1, name: { en: "Electronics" }, sales: 120 },
      { categoryId: 2, name: { en: "Apparel" },      sales: 90 },
      { categoryId: 3, name: { en: "Accessories" },  sales: 70 },
    ],
    totalCategories: 3,
    totalProducts: 87,
    chart: { labels: ["Electronics","Apparel","Accessories"], series: [50,30,20] },
  },
  heatSeries: [
    { name: "Mon", data: [...Array(7)].map((_,i)=>({x:String(i+1), y:[0,1,2,5][i%4]})) },
    { name: "Tue", data: [...Array(7)].map((_,i)=>({x:String(i+1), y:[1,0,3,4][i%4]})) },
  ],
};
